import { render, staticRenderFns } from "./AdminAddService.vue?vue&type=template&id=249d641a&scoped=true"
import script from "./AdminAddService.vue?vue&type=script&lang=js"
export * from "./AdminAddService.vue?vue&type=script&lang=js"
import style0 from "./AdminAddService.vue?vue&type=style&index=0&id=249d641a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249d641a",
  null
  
)

export default component.exports